
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
// eslint-disable-next-line
import { Validation } from 'vuelidate' //Don't remove this import, otherwise validations isnt recognized
import Axios from 'axios'
import { required, minLength, numeric, minValue } from 'vuelidate/lib/validators'
import FormField from '../components/form-field.vue'
import { gtag, gtagSendToIdQuoteRequest, dataLayer } from "../core/constants";
import { ANTIFORGERY_INPUT_NAME, BASE_URL, IS_HOUTBOUW_STORE } from '../helpers/constants'
import { GENERAL_QUOTATION_FORM_FIELDS, ADDRESS_FIELDS, COMMENTS_FIELD, CONSENT_FIELD } from '../helpers/form-constants'
import { getValidations, scrollToElement, setNecessaryFormFields } from '../helpers/functions'
import { IFormField } from '../types/forms'


@Component({
  validations() {
    const _this = this as QuotationRequest
    const validations = getValidations(
      [..._this.generalFormFields,
        ..._this.addressFormFields,
        ..._this.lastFormFields])

    validations.model.products = {
      required,
      minLength: minLength(1),
      $each: {
        productId: { required },
        quantity: { required, numeric, minValue: minValue(1) }
      }
    }
    return validations
  },
  components: { FormField }
})
export default class QuotationRequest extends Vue {
  @Prop() consentLabel: string

  @Prop() errorMessage: string

  generalFormFields: IFormField[] = GENERAL_QUOTATION_FORM_FIELDS

  addressFormFields: IFormField[] = ADDRESS_FIELDS

  lastFormFields: IFormField[] = [
    { ...COMMENTS_FIELD, required: false },
    { ...CONSENT_FIELD, label: this.consentLabel }
  ]

  model: { [key in string]: any } = { products: [{ productId: '', quantity: null }] }

  loading = false

  isSent = false

  async send(): Promise<void> {
    this.$v.$touch()
    if (this.$v.$invalid) {
      this.$nextTick(() => scrollToElement(this.$el, '.error'))
      return
    }

    this.loading = true

    try {
      const antiForgeryInput: HTMLInputElement | null = document.querySelector(`input[name=${ANTIFORGERY_INPUT_NAME}]`)
      this.model[ANTIFORGERY_INPUT_NAME] = antiForgeryInput?.value
      const res: { data: { success: boolean } } = await Axios.post(`${BASE_URL}/quoteform/submit`, this.model)
      if (res.data.success) {
        this.isSent = true

        if(IS_HOUTBOUW_STORE) {
          dataLayer.push({ event: 'generate_lead', formType: 'quote_request' })
        }

        if(window.CURRENT_STORE === 'HakronNL') {
        /* eslint-disable @typescript-eslint/camelcase */
          gtag('event', 'conversion', {
            send_to: gtagSendToIdQuoteRequest
          });
        }

        this.$nextTick(() => setTimeout(() => scrollToElement(this.$el, '.success-message'), 600))
      } else throw new Error()

    } catch (error) {
      console.error(error)
      this.$store.commit('notifications/add', { message: this.errorMessage })
    } finally {
      this.loading = false
    }
  }

  addProduct(): void {
    this.model.products.push({ productId: '', quantity: null })
  }

  created(): void {
    // set necessary formfields
    setNecessaryFormFields(this, [...this.generalFormFields, ...this.addressFormFields, ...this.lastFormFields])
  }
}
